<template>
  <ul>
    <form class="form">
      <label
        v-for="value in filteredValues"
        :key="value.id"
        class="field field--checkbox"
      >
        <span class="field__label">
          {{ value.label }} ({{ value.count }})
        </span>
        <div class="input input--checkbox">
          <input
            :checked="isFilterSelected(value)"
            type="checkbox"
            class="input__element input__element--checkbox"
            @change="handleListItemClick(value)"
          />
          <span class="input__checkbox"></span>
        </div>
      </label>
    </form>
  </ul>
</template>

<script>
import isEqual from "lodash-es/isEqual";
export default {
  name: "ListFilter",
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["change"],
  computed: {
    filteredValues() {
      return this.values.filter((value) => value.count > 0);
    },
  },
  methods: {
    isFilterSelected(value) {
      const valueInput = JSON.parse(value.input);

      const filterKey = Object.keys(valueInput)[0];
      const selectedFilters = JSON.parse(JSON.stringify(this.filters));

      const selectedFiltersHasSelectedFilter = selectedFilters?.some(
        (selectedFilter) => {
          if (isEqual(selectedFilter[filterKey], valueInput[filterKey])) {
            return true;
          }
          return false;
        }
      );

      return selectedFiltersHasSelectedFilter;
    },
    handleListItemClick(value) {
      this.$emit("change", JSON.parse(value.input));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";
</style>
